import React, { useState, useEffect } from "react";

import { trackPromise } from "react-promise-tracker";

import { verificarPastaCompartilhada } from "../../services/http/pastaCompartilhada";

import services from "../../services";

import { Modal, Badge, Avatar } from "antd";

import ModalListaUsuarios from "../ModalListaUsuarios";

import infoPastasvg from "../../assets/icons/infoPasta.svg";
import addPastaSvg from "../../assets/icons/addpasta.svg";

import "./styles.scss";
import { inforPasta } from "../../services/http/pastaService";
import { CloseOutlined } from "@mui/icons-material";

import {
  registrarDownloadArquivo,
  registrarDownloadPasta,
  registrarVisualizacaoArquivo,
  registrarVisualizacaoPasta,
} from "../../services/http/dashboardService";
import lang from "../../assets/idioma/idiomas";

const ModalCompartilharPasta = ({
  closeModal,
  openModal,
  pasta,
  handleCompartilhar,
  handleRemoverCompartilhar,
}) => {
  const { IdUser } = services.storage.getUser();
  const [usuarios, setUsuarios] = useState([]);
  const [modalUsuarios, setModalUsuarios] = useState(false);
  const [usuariosBusca, setUsuariosBusca] = useState([]);
  const [pastaJaCompartilhada, setPastaJaCompartilhada] = useState(false);
  const [info, setInfo] = useState([]);

  const showModalUsuarios = () => {
    setModalUsuarios(true);
  };
  const closeModalUsuarios = () => {
    setModalUsuarios(false);
  };

  useEffect(() => {
    validarSePastaJaCompartilhada();
    buscarDetalhesPasta();

    return () => {
      setUsuarios([]);
    };
  }, []);

  const buscarDetalhesPasta = () => {
    trackPromise(
      inforPasta(pasta.id)
        .then((res) => {
          if (!res.fail && res.data) {
            setInfo(res.data);
            registrarVisualizacaoPastas(pasta.id);
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  const validarSePastaJaCompartilhada = () => {
    trackPromise(
      verificarPastaCompartilhada(IdUser, pasta.id)
        .then((res) => {
          if (!res.fail && res.data) {
            setPastaJaCompartilhada(res.data);
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  const registrarVisualizacaoPastas = (idPasta) => {
    trackPromise(
      registrarVisualizacaoPasta(idPasta, false)
        .then((res) => {
          if (!res.fail) {
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  const showIniciais = (nome) => {
    let nomecompleto = nome.replace(".", " ");
    var iniciais = nomecompleto.match(/\b(\w)/gi);
    var sobrenomes = iniciais.splice(0, iniciais.length).join("").toUpperCase();
    return sobrenomes;
  };

  return (
    <div>
      <Modal
        title={
          <span className="modal-title-compartilhar">{lang.Compartilhar}</span>
        }
        visible={openModal}
        className="modal-novo"
        footer={false}
        closable={false}
        destroyOnClose={false}
      >
        <CloseOutlined
          onClick={() => closeModal(false)}
          className="custom-close-icon"
        />
        <div>
          <div className="modal-compartilhar-header">
            <div className="modal-compartilhar-info-pasta">
              <div className="modal-compartilhar-img">
                <img src={infoPastasvg} />
              </div>
              <div className="modal-compartilhar-nome-quantidade-pasta">
                <div>
                  <span className="span-compartilhar-nome-pasta">
                    {pasta.nome.length > 20
                      ? `${pasta.nome.slice(0, 17)}...`
                      : pasta.nome}
                  </span>
                </div>
                <div>
                  <span className="span-compartilhar-pasta-quantidade">
                    {info.quantidadePastas} pastas e {info.quantidadeArquivos}{" "}
                    {lang.Arquivos}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="modal-compartilhar-usuarios-acesso fundoModalCompartilhar">
            <div className="modal-compartilhar-usuario-acesso-title">
              {usuarios.length > 0 && (
                <span className="usuarios-acesso">
                  {lang.Usuarios_com_acesso}
                </span>
              )}
            </div>
            <div className="modal-compartilhar-usuario-acesso-lista">
              {usuarios.length > 0 &&
                usuarios.map((item) => {
                  return (
                    <div className="modal-compartilhamento-lista-usuarios">
                      <Badge size="small">
                        <Avatar
                          style={{ background: "#828282", color: "#FFFFFF" }}
                        >
                          {showIniciais(item.login)}
                        </Avatar>
                        <span className="modal-compartilhamento-nome-usuarios">
                          {item.login}
                        </span>
                      </Badge>
                    </div>
                  );
                })}
            </div>
            <div>
              <button
                className="modal-compartilhar-adicionar-usuario mb-5 p-0"
                onClick={showModalUsuarios}
              >
                <img src={addPastaSvg} alt="" />
                <span>{lang.Adicionar_usuarios}</span>
              </button>
            </div>
          </div>
          <div className="modal-compartilhar-buttons">
            {pastaJaCompartilhada?.compartilhada && (
              <button
                className="modal-compartilhar-button-remover"
                onClick={() => handleRemoverCompartilhar(pasta)}
              >
                {lang.Deixar_de_compartilhar}
              </button>
            )}
            <button
              className="modal-compartilhar-button-ok"
              onClick={() => handleCompartilhar(pasta, usuarios)}
            >
              {lang.Ok}
            </button>
          </div>
        </div>
      </Modal>

      <ModalListaUsuarios
        closeModal={closeModalUsuarios}
        openModal={modalUsuarios}
        usuarios={usuarios}
        setUsuarios={setUsuarios}
      />
    </div>
  );
};

export default ModalCompartilharPasta;
